import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { DialogueHandler, SendOnboardingEmailDialogueHandler } from './types';

const { ConfirmationDialogue } = vp;

type AccountPanelDialogueProps = {
  type: string;
  subTitle: string;
  handleDialogue: DialogueHandler<SendOnboardingEmailDialogueHandler>;
};
type FC = FunctionComponent<AccountPanelDialogueProps>;

const SendOnboardingEmailDialogue: FC = ({ type, subTitle, handleDialogue }: AccountPanelDialogueProps) => (
  <div>
    {/* Send Onboarding Email Confirmation */}
    <ConfirmationDialogue
      isVisible={type === 'confirm'}
      title="Are you sure you wish to send onboarding email?"
      subTitle=""
      status="alert"
      confirm={{
        label: 'Yes',
        action: () => handleDialogue({ type: 'confirm', state: 'success' }),
      }}
      cancel={{
        label: 'No',
        action: () => handleDialogue({ type: 'confirm', state: 'fail' }),
      }}
    />

    {/* Send Onboarding Email Success */}
    <ConfirmationDialogue
      isVisible={type === 'success'}
      title="Success! The Onboarding Email was successfully sent."
      status="success"
      subTitle=""
      confirm={{
        label: 'Back',
        action: () => handleDialogue({ type: 'send', state: 'success' }),
      }}
    />
    {/* Send Onboarding Email Fail */}
    <ConfirmationDialogue
      isVisible={type === 'error'}
      title="Error! The Onboarding Email was not sent."
      status="error"
      subTitle={subTitle}
      confirm={{
        label: 'Back',
        action: () => handleDialogue({ type: 'send', state: 'fail' }),
      }}
    />
  </div>
);
export default SendOnboardingEmailDialogue;
